export default "__VITE_ASSET__DpSu1aMi__"